import { Controller } from "@hotwired/stimulus"

// Checking a service in "Services interested in" flips that service's section
// gate ("Interested in … services?") to Yes, so its follow-up questions appear
// without a second click. One-way on purpose: unchecking never forces the gate
// back to No — the rep may have answered it deliberately.
const GATES = {
  "Tax": "interested_taxes",
  "Sales Tax": "interested_sales_tax",
  "Payroll": "interested_payroll",
  "CFO / Advisory": "interested_cfo"
}

export default class extends Controller {
  sync(event) {
    const box = event.target
    if (!box.matches('input[type="checkbox"][name$="[services_interested][]"]')) return
    if (!box.checked) return

    const gate = GATES[box.value]
    if (!gate) return

    const select = this.element.querySelector(`select[name="sales_opportunity[discovery_answers][${gate}]"]`)
    if (!select || select.value === "Yes") return

    select.value = "Yes"
    // Bubbling change re-runs the reveal/progress controllers and autosave,
    // exactly as if the rep had flipped the gate by hand.
    select.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
